import { defineMessages } from 'react-intl-next';

export default defineMessages({
    disclaimerText: {
        defaultMessage:
            'The quality, accuracy, and reliability of information generated by Atlassian Intelligence may vary.',
        description: 'Disclaimer text for Unified Help',
        id: 'unified-help.disclaimer.text.non-final',
    },
    learnWhyLink: {
        defaultMessage: 'Learn why',
        description: 'Learn why link for Unified Help disclaimer',
        id: 'unified-help.disclaimer.learn-why.non-final',
    },
});
